module.exports = __webpack_public_path__ + "img/image5.b82d3c82.png";